import { createFileRoute } from '@tanstack/react-router';

import { MetricsPage } from '@/pages/metrics/metrics-page';

export const Route = createFileRoute('/metrics')({
  component: MetricsPage,
});
